import { type Epic, combineEpics } from 'redux-observable';
import { filter, map, mergeMap, withLatestFrom } from 'rxjs';
import { request } from '@/core';
import { fetchMembersRequest } from '@/api/members';
import { tryFetchMembers, fetchMembers, setMembers } from '../actions';
import { membersByPropertyId } from '../selectors';

const tryFetchMembersEpic: Epic = (action$, state$) =>
  action$.pipe(
    filter(tryFetchMembers.match),
    withLatestFrom(state$),
    map(([{ payload }, state]) => {
      const { propertyId } = payload;

      const members = membersByPropertyId(state, { propertyId });

      if (!members) {
        return fetchMembers(payload);
      }

      return {
        type: 'MEMBERS_ALREADY_FETCHED',
      };
    }),
  );

const fetchMembersEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchMembers.match),
    request(({ payload }) => fetchMembersRequest(payload), fetchMembers),
  );

const fetchMembersSucceededEpic: Epic = (action$) =>
  action$.pipe(
    filter(fetchMembers.succeeded.match),
    mergeMap(
      ({
        payload: {
          data: members,
          originalData: { propertyId },
        },
      }) => [
        setMembers({
          propertyId,
          members,
        }),
      ],
    ),
  );

export default combineEpics(
  tryFetchMembersEpic,
  fetchMembersEpic,
  fetchMembersSucceededEpic,
);
